<script lang="ts" setup>
import './agenda.scss';
import { ref, computed, onMounted, watch } from 'vue';

import { scrollTop } from '@/utils';


const props = defineProps<{ performer?: any; }>();
const hourList = computed(() => {
    return props.performer.availability.match(/.{24}/g);;
});

</script>

<template src="./agenda.html"></template>